import {
    ServiceType,
    ThemeType,
} from '@uipath/portal-shell-util';

import { Scope } from '../constants/constants';
import { SERVICE_IDS } from '../constants/defaultServiceOrder';
import { Service } from '../models/service';
import { getSpaceName } from '../utils/urlHelper';
import { State } from './types/state';

export const defaultActiveItems = [ SERVICE_IDS.home, SERVICE_IDS.help ];

export const defaultMenuItems: Service[] = [
    {
        id: 'home',
        name: 'Home',
        scope: Scope.Global,
        serviceType: ServiceType.cloudRpa,
        svg: 'home',
        url: '//portal_/home',
    },
    {
        id: 'help',
        name: 'Help',
        scope: Scope.Global,
        serviceType: ServiceType.cloudRpa,
        svg: 'help',
        url: '//portal_/resourcecenter',
    },
];

export const defaultStoreValues: State = {
    active: getSpaceName() ?? '',
    enableThemeSwitcher: true,
    overrideTheme: '' as ThemeType,
    selectedTheme: '' as ThemeType,
    focusMode: false,
    mode: null,
    activePortalSubMenu: null,
    activeMenuSurface: null,
    activePortalToolbarSurface: null,
    activeDropdownMenuSurface: null,
    locale: '',
    overrideLocale: '',
    settingClickEmitter: null,
    handleItems: [],
    overrideAllNavItems: false,
};
